export type NotificationPrefKey =
  | "engine_on"
  | "engine_off"
  | "panic"
  | "speed_alert"
  | "engine_block_active"
  | "engine_block_released"
  | "device_disconnect"
  | "device_reconnect"
  | "gps_signal_lost"
  | "gps_signal_recovered";

export type NotificationPrefItem = { enabled: boolean };

export type NotificationPrefs = Record<NotificationPrefKey, NotificationPrefItem>;

export const NOTIFICATION_PREF_KEYS: NotificationPrefKey[] = [
  "engine_on",
  "engine_off",
  "panic",
  "speed_alert",
  "engine_block_active",
  "engine_block_released",
  "device_disconnect",
  "device_reconnect",
  "gps_signal_lost",
  "gps_signal_recovered",
];

export function buildEmptyNotificationPrefs(): NotificationPrefs {
  const result = {} as NotificationPrefs;
  for (const key of NOTIFICATION_PREF_KEYS) {
    result[key] = { enabled: false };
  }
  return result;
}

export const DEFAULT_NOTIFICATION_PREFS: NotificationPrefs =
  buildEmptyNotificationPrefs();

/** Lee del backend: todo en off salvo keys con enabled === true explícito. */
export function parseNotificationPrefsFromBackend(
  input: Partial<NotificationPrefs> | null | undefined,
): NotificationPrefs {
  const result = buildEmptyNotificationPrefs();
  if (!input || typeof input !== "object") return result;

  for (const key of NOTIFICATION_PREF_KEYS) {
    if (input[key]?.enabled === true) {
      result[key] = { enabled: true };
    }
  }
  return result;
}

/** Persiste lo enviado por el formulario (true/false explícito por key). */
export function sanitizeNotificationPrefs(
  input: Partial<NotificationPrefs> | null | undefined,
): NotificationPrefs {
  const result = buildEmptyNotificationPrefs();
  if (!input || typeof input !== "object") return result;

  for (const key of NOTIFICATION_PREF_KEYS) {
    result[key] = { enabled: input[key]?.enabled === true };
  }
  return result;
}

export function parseNotificationPrefsResponse(body: unknown): NotificationPrefs {
  const payload = body as {
    data?: { notification_prefs?: Partial<NotificationPrefs> };
    notification_prefs?: Partial<NotificationPrefs>;
  };
  const raw =
    payload?.data?.notification_prefs ??
    payload?.notification_prefs ??
    (payload as { data?: Partial<NotificationPrefs> })?.data;
  return parseNotificationPrefsFromBackend(raw as Partial<NotificationPrefs>);
}
